import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    campusItems: [],
    facultyItems: [],
    departmentItems: [],
    totalItems: 0
  },
  getters: {
    loadingStatus (state) {
      return state.loadingStatus
    },
    campusItems (state) {
      return state.campusItems
    },
    facultyItems (state) {
      return state.facultyItems
    },
    departmentItems (state) {
      return state.departmentItems
    },
    totalItems (state) {
      return state.totalItems
    }
  },
  mutations: {
    SET_LOADING_STATUS (state, payload) {
      state.loadingStatus = payload
    },
    SET_CAMPUS_ITEMS (state, payload) {
      state.campusItems = payload
    },
    SET_FACULTY_ITEMS (state, payload) {
      state.facultyItems = payload
    },
    SET_DEPARTMENT_ITEMS (state, payload) {
      state.departmentItems = payload
    },
    SET_TOTAL_ITEMS (state, payload) {
      state.totalItems = payload
    }
  },
  actions: {
    fetchCampus (context) {
      // console.log('actions fetchCampus')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/campus`).then((response) => {
        // console.log('Campus', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_CAMPUS_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    fetchFaculties (context) {
      // console.log('actions fetchFaculties')
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/faculties`).then((response) => {
        // console.log('Faculties', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_FACULTY_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    fetchDepartments (context, payload) {
      // console.log('actions fetchDepartments', payload)
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/departments/${payload.id}`).then((response) => {
        // console.log('Departments', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_DEPARTMENT_ITEMS', response.data)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    loadCampusItems ({ commit, dispatch }) {
      console.log('-> loadCampusItems')
      return Vue.axios.get(`${config.serverURI}/campus`)
    },
    loadFacultyItems ({ commit, dispatch }) {
      console.log('-> loadFacultyItems')
      return Vue.axios.get(`${config.serverURI}/faculties`)
    },
    loadDepartmentItems ({ commit, dispatch }, payload) {
      console.log('-> loadDepartmentItems')
      return Vue.axios.get(`${config.serverURI}/departments/${payload.id}`)
    },

    loadCampusItemsAsPage ({ commit, dispatch }) {
      console.log('-> loadItemsAsPage')
      return Vue.axios.get(`${config.serverURI}/campus`)
    },
    loadFacultyItemsAsPage (context, pagination) {
      console.log('-> loadFacultyItemsAsPage', pagination)
      // return Vue.axios.get(`${config.serverURI}/faculties/page`, { params: pagination })
      context.commit('SET_LOADING_STATUS', true)
      Vue.axios.get(`${config.serverURI}/faculties/page`, { params: pagination }).then((response) => {
        console.log('Faculties', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_TOTAL_ITEMS', response.data.totalItems)
        context.commit('SET_FACULTY_ITEMS', response.data.items)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },
    loadDepartmentItemsAsPage (context, pagination) {
      console.log('-> loadDepartmentItemsAsPage', pagination)
      // return Vue.axios.get(`${config.serverURI}/departments/${payload.id}/page`, { params: payload })
      context.commit('SET_LOADING_STATUS', true)
      // Vue.axios.get(`${config.serverURI}/departments/${payload.id}/page`, { params: payload }).then((response) => {
      Vue.axios.get(`${config.serverURI}/departments/page`, { params: pagination }).then((response) => {
        console.log('Departments', response.data)
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_TOTAL_ITEMS', response.data.totalItems)
        context.commit('SET_DEPARTMENT_ITEMS', response.data.items)
      }).catch((error) => {
        console.log(error)
        context.commit('SET_LOADING_STATUS', false)
        context.dispatch('snackbarOnLoadFail', error)
      })
    },

    createCampus ({ commit, dispatch }, payload) {
      console.log('-> createCampus', payload)
      return Vue.axios.post(`${config.serverURI}/campus`, payload)
    },
    updateCampus ({ commit, dispatch }, payload) {
      console.log('-> updateCampus', payload)
      return Vue.axios.put(`${config.serverURI}/campus/${payload.id}`, payload)
    },
    deleteCampus ({ commit, dispatch }, payload) {
      console.log('-> deleteCampus', payload)
      return Vue.axios.delete(`${config.serverURI}/campus/${payload.id}`)
    },
    createFaculty ({ commit, dispatch }, payload) {
      console.log('-> createFaculty', payload)
      return Vue.axios.post(`${config.serverURI}/faculties`, payload)
    },
    updateFaculty ({ commit, dispatch }, payload) {
      console.log('-> updateFaculty', payload)
      return Vue.axios.put(`${config.serverURI}/faculties/${payload.id}`, payload)
    },
    deleteFaculty ({ commit, dispatch }, payload) {
      console.log('-> deleteFaculty', payload)
      return Vue.axios.delete(`${config.serverURI}/faculties/${payload.id}`)
    },
    createDepartment ({ commit, dispatch }, payload) {
      console.log('-> createDepartment', payload)
      return Vue.axios.post(`${config.serverURI}/departments`, payload)
    },
    updateDepartment ({ commit, dispatch }, payload) {
      console.log('-> updateDepartment', payload)
      return Vue.axios.put(`${config.serverURI}/departments/${payload.id}`, payload)
    },
    deleteDepartment ({ commit, dispatch }, payload) {
      console.log('-> deleteDepartment', payload)
      return Vue.axios.delete(`${config.serverURI}/departments/${payload.id}`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common/university.js